import { createAction } from '@reduxjs/toolkit'

export enum Field {
  INPUT = 'INPUT',
  OUTPUT = 'OUTPUT',
}

export const selectCurrency = createAction<{ field: Field; currencyId: string }>('pay/selectCurrency')
export const switchCurrencies = createAction<void>('pay/switchCurrencies')
export const typeInput = createAction<{ field: Field; typedValue: string }>('pay/typeInput')
export const replacePayState = createAction<{
  field: Field
  typedValue: string
  inputCurrencyId?: string
  outputCurrencyId?: string
  recipient: string | null
}>('pay/replacePayState')
export const setRecipient = createAction<{ recipient: string | null }>('pay/setRecipient')
